import Controller, { OnMount, OnOpen, OnUnmount } from '@philips-internal/oswald-ui-core/lib/client';

import { EncounterPatientDetailCpoeAliases, FragmentNames } from '../../codegen/index';
import InformationBarUtils from '../commons/header/information-bar-header-utils';
import BaseController from '../BaseController';
import CpoeService, { CpoeConfigurations } from './services/cpoe-service';
import { BrowserService } from '../commons/browser/browser-service';

@Controller({ component: EncounterPatientDetailCpoeAliases.GENERAL_LAYOUT_CPOE,
  fragment: FragmentNames.ENCOUNTER_PATIENT_DETAIL_CPOE })
class EncounterPatientDetailCpoeController extends BaseController {

  @OnOpen({target: FragmentNames.ENCOUNTER_PATIENT_DETAIL_CPOE})
  handleOpenEncouterPatientDetail(): void {
    const event = new CustomEvent('setCollapsedInformationBar', {detail: false});
    dispatchEvent(event);
  }

  @OnMount({target: EncounterPatientDetailCpoeAliases.GENERAL_LAYOUT_CPOE})
  handleMountGeneralLayoutCpoe(): void {
    InformationBarUtils.collapsedBar = true;

    this.getCpoeConfigurations()

    const event = new CustomEvent('setCollapsedInformationBar', {detail: false});
    dispatchEvent(event);
  }

  @OnUnmount({target: EncounterPatientDetailCpoeAliases.GENERAL_LAYOUT_CPOE})
  handleUnmountGeneralLayoutCpoe(): void {
    const event = new CustomEvent('setCollapsedInformationBar', {detail: true});
    dispatchEvent(event);
  }

  private getCpoeConfigurations(): void {
    const { encounterId, patientId, nrSequencia } = this.historyService.getCurrentRouteParams();

    CpoeService.getRevalidationRule().then((revalidationRuleId) => {
      CpoeService.loadConfigurationsCpoe()
        .then((configurationsCpoe: CpoeConfigurations) => {
          this.context.set({
            browser: BrowserService.detectBrowser(),
            configurationsCpoe,
            encounterId,
            nrSequencia,
            patientId,
            revalidationRuleId
          });
        });
    })
  }
}

export default EncounterPatientDetailCpoeController;
